import { AppPage } from "@@/pages/app-page";
import { PageLoad } from "@@/pages/page-load";
import { appPageIdFactory } from "@@/pages/page-navigation/page-navigation-context";
import { HeadTitle } from "@@/shared/head-title";
import { useTheme } from "@emotion/react";
import { useLocation } from "react-router";
import { GiftCardPurchase } from "./gift-card-purchase";
import { useGiftCardData } from "./use-gift-card-data";

const GiftCardPurchaseWizardPage = () => {
    const theme = useTheme();
    const { pathname } = useLocation();
    const { isLoading, provider, giftCard } = useGiftCardData();
    if (isLoading || !provider || !giftCard) {
        return <PageLoad backgroundColor={theme.colors.default.background} />;
    }

    return (
        <>
            <HeadTitle
                title={[
                    giftCard?.meta.title,
                    provider?.meta.title ?? provider?.slug,
                ]}
            />
            <AppPage
                pageId={appPageIdFactory(pathname)}
                forgetScrollPosition
                anchors={[]}>
                <HeadTitle title={giftCard?.meta.title} />
                <GiftCardPurchase
                    provider={provider}
                    product={giftCard}
                    hideLinkToShop={false}
                />
            </AppPage>
        </>
    );
};

export { GiftCardPurchaseWizardPage };
